<div class="pageheader">
    <div class="page-title">
        <h1>Reports</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">
                <span>Refresh</span>
                <ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
            <button class="btn btn-link" *bizPermissionRequired="'Reports_Action_Report_Create'"
                (click)="grid.addNewItem()">
                <span>Create new</span>
                <ep-svg-icon icon="plus"></ep-svg-icon>
            </button>
            <app-change-log-link *bizPermissionRequired="'Reports_Action_ShowLog'" [title]="'Reports log'">
                <app-change-log-link-entity type="Report"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<app-reports-overview-grid #grid [reportConfigurations]="reportConfigurations" (deleteReportConfiguration)="onDeleteReportConfiguration($event)">
</app-reports-overview-grid>
